function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


const showPopup = function() {
  $("body").addClass("xs-enable-popup");
};
const hidePopup = function() {
  $("body").removeClass("xs-enable-popup");
}

$(function(){
  const COOKIE = "xs_redirect";
  console.log(getCookie(COOKIE));
  
//   if ( getCookie(COOKIE) != "us" && Shopify.shop_hosts == undefined){
//     showPopup();
//   }
  showPopup();
  
  $("[data-xs-redirect]").on("click",function(e){
    e.preventDefault();
    let r = $(this).attr('data-xs-redirect');
    if( r == "us" ){
      setCookie(COOKIE, "us", 3);
      hidePopup();
    } else {
      window.location = $(this).attr('href');
    }
  });
});